import InfoTilesType from '~/components/@types/infoTiles';
import WeddingWebsites from '@zola/zola-ui/src/assets/images/icons/wedding_websites.svg';
import WeddingGuests from '@zola/zola-ui/src/assets/images/icons/wedding_guests.svg';
import WeddingChecklist from '@zola/zola-ui/src/assets/images/icons/wedding_checklist.svg';

const assetPrefix = `${process.env.ASSET_PATH}/static-preauth/images/PaperLP/loveCreating`;

// TODO: add imgAlt
const tileContent: InfoTilesType[] = [
  {
    className: 'wedding-websites',
    imgSrc: WeddingWebsites,
    imgAlt: 'website icon',
    heading: 'Free Wedding Websites',
    dek: 'Explore over 250 designs that are all easy to customize and seamlessly integrate your Zola registry.',
    ctaLink: '/wedding-planning/website',
    ctaCopy: 'Check Them Out',
  },
  {
    className: 'wedding-invitations',
    imgSrc: `${assetPrefix}/icon-designs.svg`,
    imgAlt: 'wedding invitation icon',
    heading: 'Beautiful Invites + Paper',
    dek: 'Shop custom save the dates and wedding invitations, all with friendly prices and free shipping.',
    ctaLink: '/wedding-planning/save-the-date/shop',
    ctaCopy: 'Shop Now',
  },
  {
    className: 'wedding-guests',
    imgSrc: WeddingGuests,
    imgAlt: 'wedding guest icon',
    heading: 'Free Guest List Manager',
    dek: 'Collect addresses, track RSVPs, and more with this tool that syncs with our wedding websites and invites tools.',
    ctaLink: '/wedding-planning/guests',
    ctaCopy: 'Learn More',
  },
  {
    className: 'wedding-checklist',
    imgSrc: WeddingChecklist,
    imgAlt: 'wedding checklist icon',
    heading: 'Free Wedding Checklist',
    dek: 'We’ll build you a custom to-do list for your entire planning journey based on your unique wedding details.',

    ctaLink: '/wedding-planning/checklist',
    ctaCopy: 'Take A Look',
  },
];

export default tileContent;
